// extracted by mini-css-extract-plugin
module.exports = {"root":"NotLoginLayout_root__3rZI3","app":"NotLoginLayout_app__iqYjX","main":"NotLoginLayout_main__2lJdD"};